const initialSidebarState = [
  { id: "dashboard", isShowed: true, isAllowed: true, title: "Dashboard" },
  {
    id: "hq",
    isShowed: false,
    isAllowed: false,
    title: "HQ",
    childs: [
      {
        id: "hq_stockist",
        isShowed: false,
        isAllowed: false,
        title: "Stockist",
      },
      {
        id: "hq_dropship_affiliate",
        isShowed: false,
        isAllowed: false,
        title: "Dropship Affiliate",
      },
    ],
  },
  {
    id: "agent",
    isShowed: true,
    isAllowed: false,
    title: "Agent",
    childs: [
      {
        id: "my_purchase",
        isShowed: true,
        isAllowed: true,
        title: "My Purchase",
      },
    ],
  },
  { id: "orders", isShowed: true, isAllowed: true, title: "My Orders" },
  {
    id: "products",
    isShowed: true,
    isAllowed: true,
    title: "My Product",
    childs: [
      {
        id: "product-allproduct",
        isShowed: true,
        isAllowed: true,
        title: "All Product",
        childs: [
          { id: "product-add", isShowed: true, isAllowed: true, title: "Add" },
          {
            id: "product-import",
            isShowed: false,
            isAllowed: false,
            title: "Import",
          },
        ],
      },
      {
        id: "product-categories",
        isShowed: true,
        isAllowed: true,
        title: "Categories",
      },
      {
        id: "product-variations",
        isShowed: true,
        isAllowed: true,
        title: "Variations",
      },
      {
        id: "product-collections",
        isShowed: true,
        isAllowed: true,
        title: "Collections",
      },
    ],
  },
  {
    id: "webstore",
    isShowed: true,
    isAllowed: true,
    title: "Webstore",
    childs: [
      {
        id: "webstore-settings",
        isShowed: true,
        isAllowed: true,
        title: "Settings",
        childs: [
          {
            id: "webstore-domain",
            isShowed: true,
            isAllowed: true,
            title: "Domain",
            childs: [
              {
                id: "default-domain",
                isShowed: true,
                isAllowed: true,
                title: "Default",
              },
              {
                id: "custom-domain",
                isShowed: true,
                isAllowed: false,
                title: "Custom",
              },
              {
                id: "request-custom-domain",
                isShowed: false,
                isAllowed: false,
                title: "Request Custom",
              },
            ],
          },
          {
            id: "webstore-logo",
            isShowed: true,
            isAllowed: true,
            title: "Logo",
          },
          {
            id: "webstore-profile-photo",
            isShowed: true,
            isAllowed: true,
            title: "Profile Photo",
          },
          {
            id: "webstore-slider",
            isShowed: true,
            isAllowed: true,
            title: "Slider",
          },
          {
            id: "webstore-mobile-friendly",
            isShowed: true,
            isAllowed: true,
            title: "Mobile Friendly",
          },
          {
            id: "infinite-scroll",
            isShowed: true,
            isAllowed: true,
            title: "Infinite Scroll",
          },
          {
            id: "home-page-product-display",
            isShowed: true,
            isAllowed: false,
            title: "Product Display",
          },
          {
            id: "show-filter-control",
            isShowed: true,
            isAllowed: false,
            title: "Show Filter Control",
          },
        ],
      },
      {
        id: "google-analytic",
        isShowed: true,
        isAllowed: true,
        title: "Google Analytic",
      },
      { id: "themes", isShowed: true, isAllowed: true, title: "Themes" },
      { id: "pages", isShowed: true, isAllowed: true, title: "Pages" },
      { id: "seo", isShowed: true, isAllowed: true, title: "SEO" },
      {
        id: "checkout-additional-info",
        isShowed: true,
        isAllowed: false,
        title: "Checkout Additional Info",
      },
      {
        id: "store-newsletter",
        isShowed: true,
        isAllowed: false,
        title: "Store Newsletter",
      },
    ],
  },
  {
    id: "settings",
    isShowed: true,
    isAllowed: true,
    title: "Settings",
    childs: [
      {
        id: "shop-manager",
        isShowed: false,
        isAllowed: false,
        title: "Shop Manager",
      },
      {
        id: "store-information",
        isShowed: true,
        isAllowed: true,
        title: "Store Information",
      },
      {
        id: "shipping",
        isShowed: true,
        isAllowed: true,
        title: "Shipping",
        childs: [
          {
            id: "couriers",
            isShowed: true,
            isAllowed: true,
            title: "Couriers",
            childs: [
              {
                id: "poslaju",
                isShowed: false,
                isAllowed: false,
                title: "Poslaju",
              },
              {
                id: "poslaju_international",
                isShowed: false,
                isAllowed: false,
                title: "Poslaju International",
              },
              {
                id: "citylink",
                isShowed: false,
                isAllowed: false,
                title: "Citylink",
              },
              {
                id: "flexipack",
                isShowed: false,
                isAllowed: false,
                title: "Flexipack",
              },
              { id: "janio", isShowed: true, isAllowed: false, title: "Janio" },
              {
                id: "jne_domestic_regular",
                isShowed: true,
                isAllowed: true,
                title: "JNE Domestic Regular",
              },
              {
                id: "shipper",
                isShowed: true,
                isAllowed: false,
                title: "Shipper",
              },
            ],
          },
        ],
      },
      {
        id: "payment",
        isShowed: true,
        isAllowed: true,
        title: "Payment",
        childs: [
          { id: "avapay", isShowed: true, isAllowed: true, title: "Avapay" },
          {
            id: "credit-card",
            isShowed: true,
            isAllowed: false,
            title: "Credit Card",
          },
          { id: "paypal", isShowed: false, isAllowed: false, title: "Paypal" },
          { id: "molpay", isShowed: false, isAllowed: false, title: "Molpay" },
          {
            id: "manual-payment",
            isShowed: true,
            isAllowed: false,
            title: "Manual Payment",
          },
        ],
      },
      { id: "invoicing", isShowed: true, isAllowed: true, title: "Invoicing" },
      { id: "developer", isShowed: true, isAllowed: false, title: "Developer" },
      {
        id: "tax-information",
        isShowed: true,
        isAllowed: true,
        title: "Tax Information",
      },
    ],
  },
  {
    id: "modules",
    isShowed: true,
    isAllowed: true,
    title: "Modules",
    childs: [
      {
        id: "all-module",
        isShowed: true,
        isAllowed: true,
        title: "All Module",
      },
      {
        id: "google-shopping",
        isShowed: true,
        isAllowed: true,
        title: "Google Shopping",
      },
      {
        id: "coupon-code",
        isShowed: true,
        isAllowed: true,
        title: "Coupon Code",
      },
      {
        id: "facebook",
        isShowed: true,
        isAllowed: true,
        title: "Facebook",
        childs: [
          {
            id: "facebook-marketing",
            isShowed: true,
            isAllowed: false,
            title: "Facebook Marketing",
          },
          {
            id: "facebook-page",
            isShowed: true,
            isAllowed: true,
            title: "Facebook Page",
            childs: [
              {
                id: "fb-link-to-page",
                isShowed: true,
                isAllowed: true,
                title: "Link To Page",
              },
              {
                id: "fb-unlink-page",
                isShowed: true,
                isAllowed: true,
                title: "Unlink Page",
              },
              {
                id: "fb-change-adaccount",
                isShowed: true,
                isAllowed: true,
                title: "Change Ad Account",
              },
              { id: "fb-shop", isShowed: true, isAllowed: true, title: "Shop" },
              {
                id: "auto-pm-order",
                isShowed: true,
                isAllowed: true,
                title: "Auto PM Order",
              },
            ],
          },
          {
            id: "facebook-fanpage-autorepy",
            isShowed: false,
            isAllowed: false,
            title: "Facebook Fanpage Autorepy",
          },
        ],
      },
      {
        id: "instagram",
        isShowed: true,
        isAllowed: true,
        title: "Instagram",
        childs: [
          {
            id: "instagram-connect",
            isShowed: true,
            isAllowed: true,
            title: "Connect",
          },
          {
            id: "instagram-comment-order",
            isShowed: false,
            isAllowed: false,
            title: "Comment Order",
          },
        ],
      },
      {
        id: "messenger",
        isShowed: true,
        isAllowed: true,
        title: "Messenger",
        childs: [
          {
            id: "messenger-settings",
            isShowed: true,
            isAllowed: false,
            title: "Settings",
          },
          {
            id: "messenger-blast",
            isShowed: true,
            isAllowed: false,
            title: "Blast",
          },
        ],
      },
      { id: "blogspot", isShowed: true, isAllowed: true, title: "Blogspot" },
      { id: "twitter", isShowed: true, isAllowed: true, title: "Twitter" },
      { id: "whatsapp", isShowed: true, isAllowed: true, title: "Whatsapp" },
      {
        id: "avacredit",
        isShowed: false,
        isAllowed: false,
        title: "Avacredit",
      },
      { id: "avachat", isShowed: false, isAllowed: false, title: "Avachat" },
    ],
  },
];

export default initialSidebarState;
